var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZinc20({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#333333",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#bgGradient)",
    rx: 20,
    ry: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "55%",
    textAnchor: "middle",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 50,
    fill: "white",
    fontWeight: "bold"
  }, "\n    ZINC", /*#__PURE__*/React.createElement("tspan", {
    dy: -20,
    dx: 5,
    fontSize: 25,
    fontStyle: "italic",
    fontWeight: "lighter"
  }, "20"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZinc20);
export default __webpack_public_path__ + "static/media/zinc20.7b2f791c8e3504422238fb268c2f92dd.svg";
export { ForwardRef as ReactComponent };